import { FunctionComponent, useEffect, useState } from "react";
import useNav from "../../../../../hooks/useNav";
import { Button, Modal } from "@mui/material";
import ContainerModal from "../../../../../components/modalExportar/components/containerModal";
import ServicesAlocarBatismo from "./services";

interface AlocarBatismoProps {

}

const AlocarBatismo: FunctionComponent<AlocarBatismoProps> = () => {

  const { batismos, tarefa: { tarefas, getTarefasBatismo, selectTarefa, tarefaSelected }, gerarIngressoUsuarioFaltantes, gerarIngressoUsuarioPresentes } = ServicesAlocarBatismo()

  const { goBack } = useNav();

  const [disable, setDisable] = useState<boolean>(false);
  const [disableTarefa, setDisableTarefa] = useState<boolean>(false);

  useEffect(() => {
    if (tarefas) {
      setTimeout(() => setDisable(true), 200)
    }
  }, [tarefas])

  useEffect(() => {
    if (tarefaSelected) {
      setTimeout(() => setDisableTarefa(true), 200)
    }
  }, [tarefaSelected])

  return (<>
    <Modal
      open
      onClose={goBack}
    >
      <ContainerModal props={{
        overflow: 'hidden'
      }}>
        <div style={{ display: 'flex' }}>
          <p style={{
            fontSize: '16px',
            fontWeight: 600,
            padding: '8px',
            display: disable ? 'none' : 'inherit',
            transition: '300ms ease-in all',
            transform: tarefas ? 'translateX(-600px)' : 'none'
          }}>
            Eventos
          </p>
          <p
            style={{
              fontSize: '16px',
              fontWeight: 600,
              display: disableTarefa ? 'none' : 'inherit',
              padding: '8px',
              transition: '300ms ease-in all',
              transform: tarefas ? tarefaSelected ? 'translateX(-600px)' : 'translateX(0)' : 'translateX(600px)'
            }}
          >
            Atividades
          </p>
          <p
            style={{
              fontSize: '16px',
              fontWeight: 600,
              padding: '8px',
              transition: '300ms ease-in all',
              transform: tarefaSelected ? 'translateX(0)' : 'translateX(600px)'
            }}
          >
            Finalização
          </p>
        </div>

        <hr />
        <div
          style={{
            display: disable ? 'none' : 'grid',
            gap: '8px',
            transition: '300ms ease-in all',
            transform: tarefas ? 'translateX(-600px)' : 'none'
          }}>
          {
            batismos?.map((batismo) =>
              <Button onClick={() => getTarefasBatismo(batismo)}
                sx={{
                  boxShadow: 'none'
                }}>
                {batismo?.descricao}
              </Button>
            )
          }
        </div>
        <div
          style={{
            display: disableTarefa ? 'none' : 'grid',
            transition: '300ms ease-in all',
            gap: '8px',
            transform: tarefas ?
              tarefaSelected ? 'translateX(-600px)' : 'translateX(0)' :
              'translateX(600px)'
          }}
        >
          {
            tarefas?.map(
              (tarefa) =>
                <Button
                  sx={{
                    boxShadow: 'none'
                  }}
                  onClick={
                    () => selectTarefa(tarefa)
                  }
                >
                  {tarefa?.descricao}
                </Button>
            )
          }
        </div>
        <div
          style={{
            transition: '300ms ease-in all',
            transform: tarefaSelected ? 'translateX(0)' : 'translateX(600px)',
            padding: '4px',
            display: 'grid',
            gap: '4px'
          }}
        >
          {
            tarefaSelected ?
              <>
                <Button sx={{
                  width: '100%',
                  boxShadow: 'none'
                }}
                  variant="contained"
                  onClick={() => gerarIngressoUsuarioPresentes('presenca')}
                >
                  Inserir todos com presença
                </Button>
                <Button sx={{
                  width: '100%',
                  boxShadow: 'none'
                }}
                  color="error"
                  variant="contained"
                  onClick={() => gerarIngressoUsuarioFaltantes('presenca')}
                >
                  Inserir todos sem presença
                </Button>
              </> : false
          }
        </div>
      </ContainerModal>
    </Modal>
  </>);
}

export default AlocarBatismo;
